var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      style: { "--color": _vm.themeColor, "--lightColor": _vm.lightThemeColor },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("header", { staticClass: "header" }, [
            _c("p", { staticClass: "p1" }, [
              _vm._v(" 2020-06-20-2020-06-23 3晚 单人间 "),
              _c("span", [_vm._v("（ 该商品最多可供 1人使用）")]),
              _vm._v(" 3间 "),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handlerSaveClick },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "main" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { border: "", data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: { fixed: "left", type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "left",
                      align: "center",
                      prop: "date",
                      label: "商品序号",
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "left",
                      width: "70",
                      align: "center",
                      prop: "name",
                      label: "商品名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "60",
                      align: "center",
                      prop: "address",
                      label: "人数",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "name",
                      label: "中文名字",
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "70",
                      align: "center",
                      prop: "address",
                      label: "英文姓名",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "60",
                      align: "center",
                      prop: "address",
                      label: "性别",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "70",
                      align: "center",
                      prop: "address",
                      label: "证件类型",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      align: "center",
                      prop: "address",
                      label: "证件号码",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      prop: "address",
                      label: "联系电话",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "140",
                      align: "center",
                      prop: "address",
                      label: "最后一次修改时间",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      prop: "address",
                      label: "操作人",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "60",
                      align: "center",
                      prop: "address",
                      label: "类型",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "80",
                      align: "center",
                      prop: "address",
                      label: "国籍",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      prop: "address",
                      label: "出生日期",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      prop: "address",
                      label: "出生地",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      align: "center",
                      prop: "address",
                      label: "签发地",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      align: "center",
                      prop: "address",
                      label: "签发日期",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }